/**
 * Format a numeric amount as currency using Intl. Falls back to a plain fixed-2 string
 * with the currency code if Intl throws on an unknown currency.
 */
export function formatMoney(amount, currency, locale = 'es') {
    // Defensive: callers should pass an ISO code string, but if an object slips through
    // (e.g. a raw LS.currency), coerce to its code so we never render "[object Object]".
    const code = typeof currency === 'string'
        ? currency
        : String(currency?.code ?? '');
    try {
        return new Intl.NumberFormat(locale, { style: 'currency', currency: code }).format(amount);
    }
    catch {
        return `${amount.toFixed(2)} ${code}`.trim();
    }
}
/**
 * The merchandise total: the cart's line items when there are any, otherwise unit price × quantity.
 *
 * 🚨 The cart branch is not an optimisation. `variant.price × quantity` is the FIRST line's unit
 * price times the WHOLE cart's quantity — correct only for a single-line cart, and silently wrong
 * (usually badly) the moment the cart holds two different products. The legacy renderer kept these
 * as two functions, `cartSubtotal()` and `unitPrice * quantity`, and chose between them on
 * `isCartMode` (`form-renderer/src/form.ts:378-381`).
 */
export function computeTotal(ctx) {
    if (ctx.lineItems?.length) {
        return ctx.lineItems.reduce((sum, li) => sum + li.price * li.quantity, 0);
    }
    const qty = ctx.quantity ?? 1;
    return ctx.variant.price * qty;
}
/**
 * Interpolate the {order_total} token in submit/button text using the formatted total.
 * Unknown tokens are left untouched so future tokens degrade gracefully.
 */
export function interpolateTokens(text, ctx) {
    const total = formatMoney(computeTotal(ctx), ctx.currency, ctx.locale ?? 'es');
    return text.replace(/\{order_total\}/g, total);
}
//# sourceMappingURL=format.js.map